/**
 * Create query string from panel state
 */

export default (controlValues, searchTerm, helpsetId) => {
  let searchParams = new URLSearchParams();
  Object.keys(controlValues).forEach((controlDefId) => {
    searchParams.set(
      `${controlDefId}`,
      controlValues[controlDefId].map((item) => item.id).join(",")
    );
  });
  if (searchTerm) {
    searchParams.set("searchTerm", searchTerm);
  }
  if (helpsetId) {
    searchParams.set("helpsetId", helpsetId)
  }
  return searchParams.toString();
};
